import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    variant?: 'default' | 'gradient';
    smooth?: boolean;
    indeterminate?: boolean;
    indicatorClassName?: string;
  }
>(({ className, value, variant = 'default', smooth = false, indeterminate = false, indicatorClassName, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn(
        "h-full flex-1 rounded-full",
        indeterminate
          ? "w-1/2 animate-progress-indeterminate"
          : "w-full",
        !indeterminate && !smooth && "transition-transform duration-500 ease-out",
        indicatorClassName ? indicatorClassName : (
          // Beide Zweige sind Vollton. Der Ternaer bleibt trotzdem stehen,
          // damit die `variant`-Prop bis S16 typseitig und in ihren sechs
          // Aufrufern unveraendert weiterlebt; S16 loescht ihn in einer Zeile.
          variant === 'gradient'
            ? "bg-primary"
            : "bg-primary"
        ),
        !indeterminate && value !== undefined && value < 100 && [
          "relative overflow-hidden",
          "after:absolute after:inset-0",
          "after:bg-gradient-to-r after:from-transparent after:via-white/25 after:to-transparent",
          "after:animate-shimmer after:bg-[length:200%_100%]",
        ]
      )}
      style={indeterminate ? undefined : { transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
